<div class="component-container">
   
  <div class="content-container">

    <swiper-container 
      #mainSwiper
      class="main-swiper"
      [allowTouchMove]="false"
      [simulateTouch]="false">
      
      <!-- Slide 1: Main UI with component name, image preview, and finish button -->
      <swiper-slide class="main-slide">
        <div class="slide-content">
          <p class="header-text">{{ 'Create Component' | translate }}</p>

          <div class="bl-input" data-tutorial-target="create-component-name">
            <mat-form-field class="large-mat">
              <input matInput [(ngModel)]="componentName" (ngModelChange)="onComponentNameChange($event)" [placeholder]="'Component Name' | translate">
            </mat-form-field>
          </div>

          <!-- Preview image that's clickable -->
          <div class="flex-list-item card-container" data-tutorial-target="create-component-icon-preview">
            <img (click)="onImageClick()" class="card-image clickable-image" [src]="getDisplayImage()">
          </div>

          <button class="max-btn mat-primary-lighter" (click)="createComponent()" mat-button mat-raised-button color="primary" data-tutorial-target="create-component-finish">{{ 'Finish' | translate }}</button>
        </div>
      </swiper-slide>

      <!-- Slide 2: Image selection options -->
      <swiper-slide class="main-slide">
        <app-photo-selector
          [selectedCuratedImageUrl]="selectedCuratedImage"
          [backButtonCallback]="returnToFirstSlide.bind(this)"
          [tutorialTargetPrefix]="'create-component'"
          (imageSelected)="onCuratedImageSelected($event)"
          (imageUploaded)="onImageUploaded($event)">
        </app-photo-selector>
      </swiper-slide>

    </swiper-container>
 
  </div>
    
  

</div>
